export const KEY_CODES = {
  DOWN_ARROW_KEY: 40,
  UP_ARROW_KEY: 38,
  ENTER: 13
}
